import general from './general.json';
import exception from './exception.json';

import camera from './camera.json';

import Root from './Root.json';

import cameraCameraChildError from './cameraCameraChildError.json';
import cameraCameraChildConfirmation from './cameraCameraChildConfirmation.json';

import componentsMaintenanceView from './componentsMaintenanceView.json';
import componentsCameraPageShootCardAuto from './componentsCameraPageShootCardAuto.json';

import componentsfacetrackerFaceDirectionModal from './componentsfacetrackerFaceDirectionModal.json';
import componentsUnsupportView from './componentsUnsupportView.json';
import passVaccine from './passVaccine.json';
import error from './error.json';
import scamAlert from './scamAlert.json';
import translations from '../../i18nAutoGenerated/vi/translations.json';
import exceptions from '../../i18nAutoGenerated/vi/exceptions.json';
import documentNames from '../../i18nAutoGenerated/vi/documentNames.json';
import documentShortNames from '../../i18nAutoGenerated/vi/documentShortNames.json';

export default {
  ...translations,
  exceptions,
  documentNames,
  documentShortNames,
  general,
  exception,
  camera,
  Root,
  cameraCameraChildError,
  cameraCameraChildConfirmation,
  componentsMaintenanceView,
  componentsCameraPageShootCardAuto,
  componentsfacetrackerFaceDirectionModal,
  componentsUnsupportView,
  passVaccine,
  error,
  scamAlert
};
